import { SearchOutlined } from "@mui/icons-material";
import React from "react";
import styled from "styled-components";

const SearchBarContainer = styled.div`
  max-width: 650px;
  display: flex;
  width: 100%;
  border: 2px solid ${({ theme }) => `${theme.secondary}20`};
  border-radius: 16px;
  cursor: text;
  padding: 16px 24px;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text_secondary};
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  
  &:hover {
    border-color: ${({ theme }) => `${theme.secondary}40`};
    box-shadow: 0 8px 24px rgba(151, 71, 255, 0.15);
  }
  
  &:focus-within {
    border-color: ${({ theme }) => theme.secondary};
    box-shadow: 0 8px 32px rgba(151, 71, 255, 0.25);
    background: ${({ theme }) => theme.card};
  }
  
  @media (max-width: 768px) {
    padding: 14px 20px;
  }
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  background: transparent;
  color: ${({ theme }) => theme.text_primary};
  font-size: 16px;
  font-weight: 400;
  
  &::placeholder {
    color: ${({ theme }) => theme.text_secondary};
    opacity: 0.7;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const SearchBar = ({ search, handleChange }) => {
  return (
    <SearchBarContainer>
      <SearchOutlined 
        sx={{ 
          color: "inherit", 
          fontSize: "24px",
          opacity: 0.7 
        }} 
      />
      <SearchInput
        type="text"
        placeholder="Search by prompt or creator name..."
        value={search}
        onChange={(e) => handleChange(e)}
      />
    </SearchBarContainer>
  );
};

export default SearchBar;
